import { render, staticRenderFns } from "./AccountSidebarAddPayment.vue?vue&type=template&id=0382748b&"
import script from "./AccountSidebarAddPayment.vue?vue&type=script&lang=js&"
export * from "./AccountSidebarAddPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports